import type {CopilotChatReference} from '@github-ui/copilot-chat-types'
import {reactFetchJSON} from '@github-ui/verified-fetch'

export async function fetchPastedReference(url: string, signal?: AbortSignal): Promise<CopilotChatReference | null> {
  const path = `/copilot/chat-links?item_url=${encodeURIComponent(url)}`
  const response = await reactFetchJSON(path, {method: 'GET', signal})
  if (response.status === 404 || response.status === 400) return null
  if (!response.ok) throw new Error(`Failed to fetch pasted reference (${response.status})`)
  return (await response.json()) as CopilotChatReference
}
